import Link from 'next/link'

import type { Breadcrumbs } from '@lib/types'

type Props = {
	breadcrumbs: Breadcrumbs
	shouldHideLastItem?: boolean
}

export default function PageBreadcrumbs({ breadcrumbs, shouldHideLastItem = false }: Props) {
	if (shouldHideLastItem) {
		breadcrumbs.pop()
	}

	// do not render anything if breadcrumbs are empty
	if (breadcrumbs?.length === 0) {
		return null
	}

	return (
		// A11Y: Added aria-label to distinguish from main navigation landmark
		<nav aria-label="Breadcrumb" className="mb-4">
			<ul className="flex">
				{breadcrumbs.map((breadcrumb, index) => (
					<li className="max-lg:text-sm" key={breadcrumb.path}>
						<Link legacyBehavior href={breadcrumb.path}>
							<a className="text-gray-500">{breadcrumb.title}</a>
						</Link>
						{index !== breadcrumbs.length - 1 && <span className="px-3 text-gray-300">/</span>}
					</li>
				))}
			</ul>
		</nav>
	)
}
